module.exports = __webpack_public_path__ + "static/media/IM Logo Blue.ece664a6.png";